// Frontend templates for "Send to Prescriber" functionality
// These templates support variable substitution using {{variableName}} syntax

export const PRESCRIBER_TEMPLATES = {
  MANUAL: {
    name: "Send to Prescriber",
    content:
      "Dear {{providerFirstName}} {{providerLastName}},\n\nThank you for your referral of {{patientFirstName}} {{patientLastName}} (DOB: {{patientDob}}) for {{medication}}.\n\nBest regards,\n\n\n\n\n\n\n\nFaxed from Lamar Health on {{today}}",
  },
  FAX: {
    name: "Send to Prescriber - Fax",
    content:
      "Dear {{providerFirstName}} {{providerLastName}},\n\nThank you for your referral of {{patientFirstName}} {{patientLastName}} (DOB: {{patientDob}}) for {{medication}}.\nA prior authorization is required for this medication and has been pre-filled for your convenience.\n\nPlease sign and submit to insurance.\n\nBest regards,\n\n\n\n\n\n\n\nFaxed from Lamar Health on {{today}}",
  },
  COVERMYMEDS: {
    name: "Send to Prescriber - CoverMyMeds",
    content:
      'Dear {{providerFirstName}} {{providerLastName}},\n\nThank you for your referral of {{patientFirstName}} {{patientLastName}} (DOB: {{patientDob}}) for {{medication}}.\nA submission has been started in CoverMyMeds portal.\n\n1. Please login to go.covermymeds.com/login and click "Enter a Key"\n\n2. Enter the patient\'s last name, date of birth, and the Key provided below\n\nKey: {{portalSubmissionId}}\nPatient Last Name: {{patientLastName}}\nDOB: {{patientDob}}\n\n3. Review the filled PA and click "Send to Plan" for approval\n\nBest regards,\n\n\n\n\n\n\n\nFaxed from Lamar Health on {{today}}',
  },
};

// Template variable mapping from OrderInfo fields
export function getTemplateVariables(orderInfo) {
  if (!orderInfo) return {};

  return {
    patientFirstName: orderInfo.patientFirstName || "",
    patientLastName: orderInfo.patientLastName || "",
    providerFirstName: orderInfo.providerFirstName || "",
    providerLastName: orderInfo.providerLastName || "",
    patientDob: orderInfo.patientDob || "",
    medication: orderInfo.medication || "",
    orderKey: orderInfo.orderKey || "",
    portalSubmissionId: orderInfo.orderSubmission?.portalSubmissionId || "",
    today: new Date().toLocaleDateString(),
  };
}
